exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home2[data-v-4c3f2fa7]{text-align:left}.div_question[data-v-4c3f2fa7]{border:2px solid transparent;padding:4px;clear:both;margin:2px auto 10px;width:96%;height:auto}.div_title_question_all[data-v-4c3f2fa7]{padding-top:2px;font-size:15px;color:#444;font-weight:700;height:auto;line-height:20px;position:relative}.div_title_question[data-v-4c3f2fa7]{float:left;width:100%}", ""]);

// exports
